import axios from 'axios';
import Common from './Common';
export default {
    getFollowings(id) {
        return axios.get(Common.api + 'buyer-followings/' + id);
    },
    getFollowers(id) {
        return axios.get(Common.api + 'seller-followers/' + id);
    },
    getFavourites(id, i) {
        return axios.get(Common.api + 'get-my-favourites/' + id + '/' + i);
    },
    // sabiks
    getAllArea() {
        return axios.get(Common.api + 'residentials');
    },
    getAllAgeGroup() {
        return axios.get(Common.api + 'age-groups');
    },
    getUserBasic(id) {
        return axios.get(Common.api + 'get-basic-profile/' + id);
    },
    //
    getRegistration1() {
        return axios.get(Common.api + 'seller-reg-first');
    },
    sendFollow(id, i) {
        return axios.get(Common.api + 'follow-seller/' + id + '/' + i)
    },
    sendRemoveFollow(id, i) {
        return axios.get(Common.api + 'unfollow-seller/' + id + '/' + i)
    },
    getFollow(id, i) {
        return axios.get(Common.api + 'check-follow-status/' + id + '/' + i)
    },
    create(data) {
        return axios.post(Common.api + 'seller-login', data);
    },
    createResgistration1(data) {
        return axios.post(Common.api + 'seller-reg-first', data);
    },
    createResgistration2(data) {
        return axios.post(Common.api + 'seller-reg-second', data);
    },
    update(id, data) {
        return axios.put(Common.api + 'seller-login' + id, data);
    }
}